import { render, staticRenderFns } from "./updateme.vue?vue&type=template&id=036e8baf"
import script from "./updateme.vue?vue&type=script&lang=js"
export * from "./updateme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports